import React from "react";
import Navbar from "./common/Navbar";
import SubFooter from "./common/SubFooter";
import Footer from "./common/Footer";
import InnerExperiences from "./inner-components/Experiences";
import { ExperienceArr } from "./data/ExperienceData";

const Experiences = () => {
  return (
    <React.Fragment>
      <main className="flex-shrink-0">
        <Navbar />
        <div className="container px-5">
          <div className="text-center mb-5">
            <h1 className="display-6 fw-bolder mb-0">
              <span className="text-gradient d-inline">Experiences</span>
            </h1>
          </div>
          <div className="row gx-5 justify-content-center">
            <div className="col-lg-12 col-xl-12 col-xxl-10">
              <section>
                {ExperienceArr.map((item) => (
                  <InnerExperiences key={item} detail={item} />
                ))}
              </section>
            </div>
          </div>
        </div>
      </main>
      <SubFooter />
      <Footer />
    </React.Fragment>
  );
};

export default Experiences;
